module.exports = (typeof Array.from === 'function' ?
  Array.from :
  require('./polyfill')
);



//////////////////
// WEBPACK FOOTER
// ./~/.2.1.1@array-from/index.js
// module id = 293
// module chunks = 3